import { render, staticRenderFns } from "./SelfRegisterView.vue?vue&type=template&id=e355516e&scoped=true"
import script from "./SelfRegisterView.vue?vue&type=script&lang=ts"
export * from "./SelfRegisterView.vue?vue&type=script&lang=ts"
import style0 from "./SelfRegisterView.vue?vue&type=style&index=0&id=e355516e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e355516e",
  null
  
)

export default component.exports